<div class="paginator-title m-b-1">
  Showing
  {{ 1 + pageIndex * pageSize }}
  -
  {{ getItemsEdgeNumber() }}
  of {{ total }} items
</div>
